<template>
  <div id="app">
    <div v-wechat-title="headerTitle" img-set=" "></div>
    <router-view></router-view>
  </div>
</template>
<script>
import browser from "@/utils/browser";
import { mapGetters } from "vuex";

export default {
  async mounted() {
    //苹果x以上按钮判断
    if (browser.versions.isIPhoneXOrAbove) {
      console.log("苹果x以上判断true");
      this.$store.commit("changeIphoneX", true);
      this.$store.commit("changeIphoneXBottom", true);
    } else {
      console.log("苹果x以上判断false");
      this.$store.commit("changeIphoneX", false);
      this.$store.commit("changeIphoneXBottom", false);
    }
    //安卓判断
    if (browser.versions.androidDevice) {
      this.$store.commit("changeAndroid", true);
    } else {
      this.$store.commit("changeAndroid", false);
    }
    //判断是否在小程序
    const isInMiniProgram = await this.$isInMiniProgram;

    if (browser.versions.mobile && !browser.versions.weChat) {
      this.$store.commit("changeVantPickeStyle", true);
    } else {
      this.$store.commit("changeVantPickeStyle", false);
    }

    if (browser.versions.weChat || browser.versions.Ali) {
      this.$store.commit("changeWeChat", true);
    } else {
      this.$store.commit("changeWeChat", false);
    }
    if (navigator.userAgent.match(/iPhone/i)) {
      console.log("screen.height", screen.height);
      console.log("screen.width", screen.width);
    }
  },
  computed: {
    ...mapGetters({
      headerTitle: "getHeaderTitle",
    }),
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/App.vue